import { render, staticRenderFns } from "./BoxEdit.vue?vue&type=template&id=050ccfea"
import script from "./BoxEdit.vue?vue&type=script&lang=js"
export * from "./BoxEdit.vue?vue&type=script&lang=js"
import style0 from "./BoxEdit.vue?vue&type=style&index=0&id=050ccfea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports